const answers = {};
const answersArray = [];
const answersObject = {};

const questions = [
  {
    id: 1,
    question: "Is your breast size closer to an orange or a cantaloupe?",

    type: "radio",
    options: ["Orange", "Cantaloupe"],
    entry: "entry.57956041",
    //change hide previous to true as introduction has been removed
    hidePrevious: true,
    hideNext: true,
    key: "fruit1",
  },
  {
    id: 2,
    question: "Got it - orange.  Which of these is closest to your size?",
    questionDescription: "fruit2",
    type: "radio",
    options: ["Tangerine", "Orange", "Grapefruit"],
    entry: "entry.207412314",
    visibleIf: (answers) => answers[1] === "Orange",
    hidePrevious: false,
    hideNext: true,
    key: "fruit2",
  },
  {
    id: 3,
    question: "Got it - cantaloupe.  Which of these is closest to your size?",
    questionDescription: "fruit2",
    type: "radio",
    options: ["Grapefruit", "Cantaloupe", "Small Watermelon"],
    entry: "entry.207412314",
    visibleIf: (answers) => answers[1] === "Cantaloupe",
    hidePrevious: false,
    hideNext: true,
    key: "fruit2",
  },
  {
    id: 4,
    question: "What cup size do you usually wear?",
    questionDescription: "cup",
    type: "radio",
    options: [
      "AA",
      "A",
      "B",
      "C",
      "D",
      "DD",
      "DDD",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J+",
    ],
    entry: "entry.430738311",
    hidePrevious: false,
    hideNext: true,
    key: "cupSize",
  },
  {
    id: 5,
    question: "And your band size?",
    type: "radio",
    options: [
      "28",
      "30",
      "32",
      "34",
      "36",
      "38",
      "40",
      "42",
      "42+",
      "I don't know",
    ],
    entry: "entry.954530919",
    hidePrevious: false,
    hideNext: true,
    key: "bandSize",
  },

  {
    id: 6,
    question: "What size tops do you usually wear?",
    type: "radio",
    options: ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXL+"],
    entry: "entry.1742590003",
    hidePrevious: false,
    hideNext: true,
    key: "topLetter",
  },
  {
    id: 7,
    question:
      "Is there anything in your wardrobe that you wear that is a size XXS?",
    type: "radio",
    options: ["Yes", "No"],
    hidePrevious: false,
    hideNext: true,
    key: "XXS",
    entry: "entry.123",
    visibleIf: (answers) => answers[6] === "S" || answers[6] === "XS",
  },
  {
    id: 8,
    question:
      "Is there anything in your wardrobe that you wear that is a size XS?",
    type: "radio",
    options: ["Yes", "No"],
    hidePrevious: false,
    hideNext: true,
    key: "XS",
    entry: "entry.123",
    visibleIf: (answers) => answers[6] === "S",
  },

  {
    id: 9,
    question: "In numeric tops sizing, what number fits you best?",
    type: "radio",
    options: [
      "00",
      "0",
      "2",
      "4",
      "6",
      "8",
      "10",
      "12",
      "14",
      "16",
      "18",
      "20",
      "20+",
      "I don't know",
    ],
    entry: "entry.5887767",
    hidePrevious: false,
    hideNext: true,
    key: "topNumber",
  },
  {
    id: 10,
    question: "In numeric bottoms sizing, what number fits you best?",
    type: "radio",
    options: [
      "00",
      "0",
      "2",
      "4",
      "6",
      "8",
      "10",
      "12",
      "14",
      "16",
      "18",
      "20",
      "20+",
      "I don't know",
    ],
    entry: "entry.1773649768",
    hidePrevious: false,
    hideNext: true,
    key: "bottomNumber",
  },
  {
    id: 11,
    question: "What's your usual jean waist size?",
    type: "radio",
    options: [
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39+",
      "I don't know",
    ],
    entry: "entry.1646418554",
    hidePrevious: false,
    hideNext: true,
    key: "jeans",
  },
  {
    id: 12,
    question: "About how tall are you?",
    options: [
      "Under 5 feet",
      "5'0\" to  5'3\"",
      "5'3\" to 5'7\"",
      "Over 5'7\"",
    ],
    type: "radio",
    entry: "entry.1986807389",
    key: "height",
    hidePrevious: false,
    hideNext: true,
  },

  // {
  //   id: 13,
  //   question: "Enter your email to claim your free shirt.",
  //   type: "email",
  //   options: [],
  //   // No single entry for the whole question — we handle name/email separately
  //   hidePrevious: true,
  //   hideNext: false,
  //   nextButtonText: "Next",
  //   key: "email",
  // },
];

let currentQuestionIndex = 0;
let history = [];

function findNextVisibleIndex(afterIndex) {
  for (let i = afterIndex + 1; i < questions.length; i++) {
    const q = questions[i];
    if (!q.visibleIf || q.visibleIf(answers)) {
      return i;
    }
  }
  return null;
}

function initSurvey() {
  // console.log("init survey");
  Object.keys(answers).forEach((key) => delete answers[key]);
  answersArray.length = 0;
  answersObject.length = 0;
  history = [];
  currentQuestionIndex = 0;
  history.push(currentQuestionIndex);
  // renderQuestion();
  renderQuestionsWithFragment();
  updateProgress();
}

function advanceToNext() {
  const nextIndex = findNextVisibleIndex(currentQuestionIndex);

  if (nextIndex === null) {
    completeSurvey();
    return;
  }

  const surveyContainer = document.querySelector(".survey-container");

  surveyContainer.classList.remove("exit-left", "enter-right");
  surveyContainer.style.transform = "";
  surveyContainer.style.opacity = "";

  surveyContainer.classList.add("exit-left");

  setTimeout(() => {
    currentQuestionIndex = nextIndex;
    history.push(currentQuestionIndex);

    // renderQuestion();
    renderQuestionsWithFragment();
    updateProgress();
    window.scrollTo({ top: 0, behavior: "smooth" });

    surveyContainer.classList.remove("exit-left");
    surveyContainer.style.opacity = "0";
    void surveyContainer.offsetWidth;

    surveyContainer.classList.add("enter-right");

    setTimeout(() => {
      surveyContainer.style.transform = "";
      surveyContainer.style.opacity = "";
      surveyContainer.classList.remove("enter-right");
    }, 150);
  }, 150);
}

function renderQuestionsWithFragment() {
  //get current question object
  const question = questions[currentQuestionIndex];

  //get container that contains questions
  const wrapper = document.getElementById("questionsWrapper");

  //Possible Safari fix: clear wrapper content
  wrapper.replaceChildren();

  //get previous and next button and display per question object
  const nextBtn = document.getElementById("nextBtn");
  const prevBtn = document.getElementById("prevBtn");
  prevBtn.classList.toggle("btn-hidden", question.hidePrevious);
  nextBtn.classList.toggle("btn-hidden", question.hideNext);

  //change display of radio buttons based on number of questions
  let optionsClass =
    question.options.length > 4 ? "options-group-grid" : "options-group-flex";

  const fragment = document.createDocumentFragment();

  //create div in place of form for radio buttons to eliminate Safari bug
  if (question.type === "radio") {
    const formReplacement = document.createElement("div");
    formReplacement.className = "question-form";
    formReplacement.id = `div-${question.id}`;

    // question title
    const title = document.createElement("h2");
    title.className = "question-title";
    title.textContent = question.question;
    formReplacement.appendChild(title);

    let optionsContainer = null;

    if (question.type === "radio") {
      optionsContainer = document.createElement("div");
      optionsContainer.className = optionsClass;
      // Sometimes Safari caches based on the name.
      // Add date to make it unique each time
      const groupName = `question-${question.id}-${Date.now()}`;

      question.options.forEach((option, index) => {
        const label = document.createElement("label");
        label.className = "option-label-5926";
        const inputId = `q${question.id}-opt${index}`;
        const input = document.createElement("input");
        input.type = "radio";
        input.name = groupName;
        input.value = option;
        input.id = `${groupName}-option-${index}`;
        //Possible Safari Fixes
        input.autocomplete = "off";
        input.setAttribute("autocomplete", "off");

        input.addEventListener("change", () => {
          answers[question.id] = input.value;
          // console.log(answers);
          // console.log(question.id);
          answersArray.push([question.entry, input.value]);
          answersObject[question.key] = {
            answer: input.value,
            entry: question.entry,
          };

          // console.log(answersObject);
          advanceToNext();
        });
        const span = document.createElement("span");
        span.className = option === "I don't know" ? "dontKnow" : "option-text";
        span.textContent = option;
        label.htmlFor = input.id;
        label.appendChild(input);
        label.appendChild(span);
        optionsContainer.appendChild(label);
      });

      // Possible Safari fix: make sure all radio inputs are unchecked
      if (question.type === "radio") {
        // Force all radios in this group to be unchecked
        const radios = optionsContainer.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          radio.checked = false;
        });
      }
    }

    if (optionsContainer) formReplacement.appendChild(optionsContainer);

    //Add completed form to the fragment
    fragment.appendChild(formReplacement);
  }

  wrapper.appendChild(fragment);
}

function nextQuestion() {
  const question = questions[currentQuestionIndex];

  // Special handling for email question
  // if (question.type === "email") {
  //   const nameInput = document.getElementById("firstName");
  //   const emailInput = document.getElementById("email");
  //   answersObject["firstName"] = {
  //     firstName: nameInput.value,
  //     entry: "entry.1708024887",
  //   };
  //   answersObject["email"] = {
  //     email: emailInput.value,
  //     entry: "entry.1607750410",
  //   };

  // console.log(answersObject);

  //   if (nameInput && emailInput) {
  //     const nameVal = nameInput.value.trim();
  //     const emailVal = emailInput.value.trim();

  //     if (nameVal && emailVal && emailInput.checkValidity()) {
  //       answersArray.push(["entry.1708024887", nameVal]);
  //       answersArray.push(["entry.1607750410", emailVal]);
  //       answers.name = nameVal;
  //       answers.email = emailVal;
  //       advanceToNext();
  //       return;
  //     } else {
  //       alert("Please enter your name and a valid email address.");
  //       return;
  //     }
  //   }
  // }

  //Special handling for summary teaser
  // if (question.type === "summary") {
  //   // console.log("summary question");
  //   advanceToNext();
  //   return;
  // }

  // Validation for other question types
  // if (
  //   (question.type === "email" && answers[question.id] === undefined) ||
  //   answers[question.id] === null ||
  //   (Array.isArray(answers[question.id]) && answers[question.id].length === 0)
  // ) {
  //   alert("Please answer this question before proceeding.");
  //   return;
  // }

  advanceToNext();
}

function previousQuestion() {
  if (history.length <= 1) return;

  document.getElementById("nextBtn")?.classList.remove("btn-hidden");

  history.pop();
  currentQuestionIndex = history[history.length - 1];

  const surveyContainer = document.querySelector(".survey-container");

  surveyContainer.classList.remove(
    "exit-left",
    "enter-right",
    "exit-right",
    "enter-left",
  );
  surveyContainer.style.transform = "";
  surveyContainer.style.opacity = "";

  surveyContainer.classList.add("exit-right");

  setTimeout(() => {
    renderQuestionsWithFragment();
    updateProgress();
    window.scrollTo({ top: 0, behavior: "smooth" });

    surveyContainer.classList.remove("exit-right");
    surveyContainer.style.opacity = "0";
    void surveyContainer.offsetWidth;

    surveyContainer.classList.add("enter-left");

    setTimeout(() => {
      surveyContainer.style.transform = "";
      surveyContainer.style.opacity = "";
      surveyContainer.classList.remove("enter-left");
    }, 150);
  }, 150);
}

function updateProgress() {
  const progress = (history.length / (questions.length - 1)) * 100;
  document.getElementById("progressFill").style.width = `${progress}%`;
}

// weights for size
const sizeWeights = {
  alpha: 1,
  numericTop: 2,
  numericBottoms: 1,
  jeansWaist: 2,
  braBand: 1,
  xxs: 1,
};

function startOver() {
  const wrapper = document.getElementById("validation-wrapper");
  if (wrapper) {
    wrapper.hidden = true; // equivalent to display: none
  }
  initSurvey();
}

//make recommendation objects global to access in logic validation and size recommendation
let sizeRecommendation = {};

function completeSurvey() {
  document.getElementById("nextBtn")?.classList.add("btn-hidden");
  document.querySelector(".progress-text")?.classList.add("btn-hidden");

  const fruit1 = answersObject?.fruit1?.answer ?? "";
  let fruit2 = answersObject?.fruit2?.answer ?? "";
  const cupSize = answersObject?.cupSize?.answer ?? 0;
  const bandSize = answersObject?.bandSize?.answer ?? 0;
  let topLetter = answersObject?.topLetter?.answer ?? "";
  const topNumber = answersObject?.topNumber?.answer ?? null;
  const bottomNumber = answersObject?.bottomNumber?.answer ?? null;
  const jeans = answersObject?.jeans?.answer ?? "";
  const feels = answersObject?.feels?.answer ?? "";
  const height = answersObject?.height?.answer ?? 0;
  const xxs = answersObject?.XXS?.answer ?? "";
  const xs = answersObject?.XS?.answer ?? "";

  if (xs === "Yes") topLetter += "XS";

  if (xxs === "Yes") topLetter += "XXS";

  if (fruit2 === "Grapefruit") {
    fruit2 = fruit1 + fruit2;
  }

  const cupRecommendation = getCupSizeEstimate(fruit2, cupSize, bandSize);
  const recommendedCup = cupRecommendation.topSize;

  const customer = {
    alphaSize: topLetter,
    numericTop: topNumber,
    numericBottoms: bottomNumber,
    jeansWaist: jeans,
    braBand: bandSize,
    preference: feels,
    xxs: xxs,
  };

  sizeRecommendation = getShirtSizeEstimate(
    customer,
    sizeWeights,
    recommendedCup,
  );

  const wrapper = document.getElementById("questionsWrapper");

  //make sure navigation buttons are hidden

  prevBtn.classList.toggle("btn-hidden", true);
  nextBtn.classList.toggle("btn-hidden", true);

  answersObject["cupSummary"] = {
    cuSummary: cupRecommendation.actionSummary,
    entry: "entry.815853947",
  };
  answersObject["sizeSummary"] = {
    sizeSummary: sizeRecommendation.actionSummary,
    entry: "entry.1546382954",
  };
  answersObject["cupAdvice"] = {
    cupRecommendation: cupRecommendation.actionAdvice,
    entry: "entry.1521602854",
  };
  answersObject["sizeAdvice"] = {
    sizeRecommendation: sizeRecommendation.actionAdvice,
    entry: "entry.1376031157",
  };

  answersObject["firstName"] = {
    firstName: "NA",
    entry: "entry.1708024887",
  };

  answersObject["email"] = {
    firstName: "NA",
    entry: "entry.1607750410",
  };

  // console.log(answersObject);

  const entryArray = convertToEntryArray(answersObject);

  submitData(entryArray);

  largeCupFlag = sizeRecommendation.largeCupFlag;

  let recommendation = `<div class="completion-message">`;

  if (!largeCupFlag) {
    recommendation += ` <h3>${cupRecommendation.actionSummary}</h3>
  <p>${cupRecommendation.actionAdvice}</p>
  <h3>${sizeRecommendation.actionSummary}</h3>
  <p>${sizeRecommendation.actionAdvice}</p>`;
  } else {
    recommendation += `<h3>Based on your answers, we believe Full Volume will be your best fit.</h3><p>We're still perfecting this collection, but it's actively in development and coming soon.</p><h3>${sizeRecommendation.actionSummary}</h3><p>We are currently developing a Full Volume version of this size</p>`;
  }

  recommendation += ` <div class="social-media">
      <h3 class="social-media__p">Follow us on tiktok and Instagram</h3>
      <div class="social-media__buttons-container">
        <a
          href="https://www.tiktok.com/@theundun/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="7 2 35 35"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.5172 25.0575C25.4647 26.4295 24.3093 27.5306 22.8929 27.5306C22.5691 27.5306 22.2591 27.4729 21.9727 27.3675C22.2591 27.4729 22.5692 27.5306 22.893 27.5306C24.3094 27.5306 25.4648 26.4295 25.5174 25.0576L25.5224 12.8063H27.8124C28.0331 13.971 28.7405 14.9704 29.7205 15.5948C29.7208 15.5952 29.7212 15.5956 29.7215 15.596C30.4037 16.0305 31.2171 16.284 32.0903 16.284V16.9645C32.0903 16.9645 32.0903 16.9645 32.0904 16.9646V19.3405C30.4684 19.3405 28.9654 18.8334 27.7386 17.9728V24.1852C27.7386 27.2878 25.1559 29.8119 21.9812 29.8119C20.7545 29.8119 19.6169 29.4338 18.6818 28.7921C18.6813 28.7916 18.6808 28.791 18.6802 28.7905C17.1964 27.7717 16.224 26.0876 16.224 24.1846C16.224 21.0821 18.8067 18.5579 21.9814 18.5579C22.2448 18.5579 22.503 18.5791 22.7572 18.6128V19.337C19.861 19.4031 17.4865 21.5682 17.1713 24.3333C17.4868 21.5685 19.8611 19.4037 22.7571 19.3376V21.7342C22.5115 21.6591 22.2519 21.6154 21.9812 21.6154C20.5314 21.6154 19.3519 22.7683 19.3519 24.1852C19.3519 25.1719 19.9247 26.0292 20.7616 26.4596C20.7616 26.4597 20.7616 26.4597 20.7616 26.4597C21.1265 26.6474 21.541 26.7549 21.9811 26.7549C23.3975 26.7549 24.5529 25.6538 24.6055 24.2819L24.6105 12.0305H27.7385C27.7385 12.2955 27.7646 12.5545 27.8123 12.8063H25.5223L25.5172 25.0575Z"
              fill="#161823"
            />
          </svg>
        </a>

        <!-- Second icon (Instagram logo) -->
        <a
          href="https://www.instagram.com/theundun/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="8 7 35 35"
            fill="none"
          >
            <defs>
              <linearGradient
                id="igGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stop-color="#F58529" />
                <stop offset="50%" stop-color="#DD2A7B" />
                <stop offset="100%" stop-color="#8134AF" />
              </linearGradient>
            </defs>

            <!-- Instagram icon -->
            <g transform="translate(13 13)">
              <rect width="24" height="24" rx="6" fill="url(#igGradient)" />
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="3"
                fill="none"
                stroke="white"
                stroke-width="1.8"
              />
              <circle cx="12" cy="12" r="4" fill="white" />
              <circle cx="17" cy="7" r="1.5" fill="white" />
            </g>
          </svg>
        </a>
      </div>
    </div>


     </div>

`;

  /***************************** TEMPORARY LOGIC VALIDATION FOR TESTING *********************************** */
  // <div class="temporary">

  //   <button  onClick="logicValidation()">
  //     <p>Click for Logic Validation (Remove for production)</p>
  //   </button>

  // </div>`

  wrapper.innerHTML = recommendation;
  document.getElementById("progressFill").style.width = "100%";

  // PDP EMBED — notify the PDP "Find Your Fit" modal that the quiz has produced
  // a recommendation. Dispatched after innerHTML so the completion message is
  // already on screen when the PDP listener decides whether to auto-close the
  // modal. CustomEvent is a no-op when no listener is present, so the
  // standalone test harness is unaffected. largeCupFlag is forwarded so the
  // PDP can suppress its cup/size auto-apply on the "Full Volume coming soon"
  // path (where applying Medium Volume would contradict the message rendered
  // above).
  try {
    document.dispatchEvent(new CustomEvent('derby:quiz:complete', {
      detail: {
        cupSize: cupRecommendation.topSize,
        shirtSize: sizeRecommendation.topSize,
        largeCupFlag: !!sizeRecommendation.largeCupFlag
      }
    }));
  } catch (e) { /* no-op */ }
}

// temporary experts GLOBAL variable for validation
let cupExperts;
let sizeExperts;

function convertToEntryArray(answersObject) {
  if (!answersObject || typeof answersObject !== "object") {
    return [];
  }

  return (
    Object.keys(answersObject)
      .filter((key) => {
        // Skip non-field properties like "length"
        return (
          key !== "length" &&
          answersObject[key] &&
          typeof answersObject[key] === "object"
        );
      })
      .map((key) => {
        const field = answersObject[key];

        // Get the entry ID
        const entryId = field.entry;

        // Get the answer value - handle different property names
        let answer = "";
        if (field.answer !== undefined) {
          answer = field.answer;
        } else if (field.email !== undefined) {
          answer = field.email;
        } else if (field.firstName !== undefined) {
          answer = field.firstName;
        } else if (field.sizeSummary !== undefined) {
          answer = field.sizeSummary;
        } else if (field.cuSummary !== undefined) {
          answer = field.cuSummary;
        } else if (field.cupRecommendation !== undefined) {
          answer = field.cupRecommendation;
        } else if (field.sizeRecommendation !== undefined) {
          answer = field.sizeRecommendation;
        }

        return [entryId, answer];
      })
      // Optional: filter out any invalid entries
      .filter(
        ([entryId]) =>
          entryId &&
          typeof entryId === "string" &&
          entryId.startsWith("entry."),
      )
  );
}

const entryArray = convertToEntryArray(answersObject);

function logicValidation() {
  const wrapper = document.getElementById("validation-wrapper");

  let expertsHTML = `<div class="validation-message">`;
  expertsHTML += "<div><h2>Cup Choices</h2>";
  cupExperts.forEach((expert) => {
    const filtered = Object.fromEntries(
      Object.entries(expert.probs).filter(([key, value]) => value !== 0),
    );
    expertsHTML += `<p>${expert.name}: ${expert.answer}, Probs: ${JSON.stringify(filtered)}, Weight: ${expert.weight} </p>`;
  });
  expertsHTML += `</div>`;

  //cup choice data
  expertsHTML += `<div><h2>Cup Size Ranked Results</h2>`;
  rankedCup.forEach((cup) => {
    expertsHTML += `<p>Size: ${cup.size}, Probability: ${cup.probability.toFixed(3)}</p>`;
  });
  expertsHTML += `</div>`;
  //end cup data

  //build size data div
  expertsHTML += "<div><h2>Size Choices</h2>";
  sizeExperts.forEach((expert) => {
    const filtered = Object.fromEntries(
      Object.entries(expert.probs).filter(([key, value]) => value !== 0),
    );
    expertsHTML += `<p>${expert.name}: ${expert.answer}, Probs: ${JSON.stringify(filtered)}, Weight: ${expert.weight} </p>`;
  });
  expertsHTML += `<p>height: ${answersObject["height"].answer} </p>`;
  expertsHTML += `</div>`;
  //end size data

  // build ranked results
  expertsHTML += `<div>
  <h2>Shirt Size Ranked Results (normalized)</h2>
  `;
  ranked.forEach(
    (entry) =>
      (expertsHTML += `<p>Size: ${entry.size}, Probability: ${entry.probability.toFixed(3)}</p>`),
  );
  expertsHTML += "</div>";
  // end ranked resultes

  // build boosed ranked results
  expertsHTML += `<div>
  <h2>XXS and XS Adjustment Boost based on Height</h2>
  <p>Boost Factor: ${boostFactor}</p>`;

  boostedRankedNormalized.forEach(
    (entry) =>
      (expertsHTML += `<p>
      Size: ${entry.size}, Probability: ${entry.probability.toFixed(3)}
    </p>`),
  );

  expertsHTML += "</div>";
  //end boosed ranked results

  if (sizeRecommendation.alphaSizeAdjustment != "No Adjustment") {
    expertsHTML += `<div> <p>${sizeRecommendation.alphaSizeAdjustment}</p><p>${sizeRecommendation.alphaSizeRecommendation}</p></div>`;
  }
  //close parent div
  expertsHTML += `</div>`;

  // show wrapper for validation
  if (wrapper) {
    wrapper.hidden = false; // equivalent to display: none
  }

  // append html
  wrapper.innerHTML = expertsHTML;
}

const weights = { fruit: 3, cup: 1 };

//***************** Cup Size *********************** */
//************************************************** */
//global var for validation
let rankedCup = [];

function getCupSizeEstimate(fruit, cupSize, bandSize) {
  // console.log(fruit, cupSize, bandSize);
  const braSize = getBraSize(cupSize, bandSize);

  const experts = [
    {
      name: "fruit",
      answer: fruit,
      probs: getFruitSizeProbs(fruit),
      weight: weights.fruit || 1.0,
    },
    {
      name: "cup",
      answer: braSize,
      probs: getCupSizeProbs(braSize),
      weight: weights.cup || 1.0,
    },
  ].filter((e) => e.probs !== null);

  //for validation
  cupExperts = experts;
  const totalProbs = createZeroProbs();
  let totalWeight = 0;

  experts.forEach((expert) => {
    const w = expert.weight;
    totalWeight += w;
    SIZES.forEach((size) => {
      totalProbs[size] += expert.probs[size] * w;
    });
  });

  // Weighted average
  SIZES.forEach((size) => {
    totalProbs[size] /= totalWeight;
  });

  // Sort by descending probability
  rankedCup = SIZES.map((size) => ({
    size,
    probability: totalProbs[size],
  })).sort((a, b) => b.probability - a.probability);

  let top = rankedCup[0];
  const second = rankedCup[1];

  //if top and second are tied, use smallest size

  const cupIndexes = new Map(SIZES.map((size, index) => [size, index]));
  // console.log(cupIndexes);
  const topIndex = cupIndexes.get(top.size);
  const secondIndex = cupIndexes.get(second.size);

  if (Math.abs(top.probability - second.probability) < 0.1) {
    // console.log("small difference in cup size");
    if (topIndex > secondIndex) {
      top = second;
    }
  }

  //===================================

  let actionAdvice = "";
  let actionSummary = "";

  if (top.size === "Teen") {
    console.log("Teen is top size");
    actionSummary = "Your Volume: Soft Volume";
    actionAdvice =
      "Our upcoming support profile, currently in development, designed for minimal breast volume and a barely-there feel.  While Soft Volume is still in development, many customers in this range still enjoy Light Volume for added shape, though the fit may feel slightly roomier";
  }

  if (top.size === "Small") {
    actionSummary = "Your volume: Light Volume ";
    actionAdvice =
      "We think Light Volume, our patent-pending support for A-D cups, is best for you.";
  }

  if (top.size === "Medium") {
    actionSummary = "Your volume: Medium Volume ";
    actionAdvice = `We think Medium Volume, our patent-pending support for D-G cups, is best for you.`;
  }

  if (top.size === "Large") {
    actionSummary += `Consider Large Volume.`;
    actionAdvice = `We think our Large Volume is best for you`;
  }

  return {
    topSize: top.size,
    confidence: Math.round(top.probability * 100),
    distribution: ranked.map((r) => ({
      size: r.size,
      probability: Math.round(r.probability * 1000) / 10, // 1 decimal place
    })),
    numExpertsUsed: experts.length,
    totalWeight: Math.round(totalWeight * 10) / 10,
    effectiveWeights: experts.reduce((acc, e) => {
      acc[e.name] = Math.round(e.weight * 10) / 10;
      return acc;
    }, {}),
    actionAdvice,
    actionSummary,
    confidenceCategory:
      top.probability >= 0.75
        ? "high"
        : top.probability >= 0.6
          ? "good"
          : "moderate/low",
  };
}

function getBraSize(cupSize, bandSize) {
  if (["AA", "A", "B", , "H", "I", "J+"].includes(cupSize)) {
    return cupSize;
  } else if (bandSize === "42+") {
    return "42" + cupSize;
  } else {
    return bandSize + cupSize;
  }
}

// All possible sizes in your system (add more if needed, e.g. '4XL')
const SIZES = ["Teen", "Small", "Medium", "Large"];

// Helper: create a zero-filled probability object
function createZeroProbs() {
  return SIZES.reduce((acc, size) => {
    acc[size] = 0;
    return acc;
  }, {});
}

// Helper: normalize probabilities to sum to 1 (defensive)
function normalizeProbs(probs) {
  const total = SIZES.reduce((sum, size) => sum + probs[size], 0);
  if (total <= 0) return probs; // avoid division by zero
  const normalized = { ...probs };
  SIZES.forEach((size) => {
    normalized[size] /= total;
  });
  return normalized;
}

function normalizeSizeProbs(probs) {
  const total = SHIRTSIZES.reduce((sum, size) => sum + probs[size], 0);
  if (total <= 0) return probs; // avoid division by zero
  const normalized = { ...probs };
  SHIRTSIZES.forEach((size) => {
    normalized[size] /= total;
  });

  return normalized;
}

function getFruitSizeProbs(fruit) {
  if (!fruit) return null;
  const rules = {
    TANGERINE: { Small: 0.95, Teen: 0.05 },
    ORANGE: { Small: 1 },
    ORANGEGRAPEFRUIT: { Small: 0.95, Medium: 0.05 }, //after orange
    CANTALOUPEGRAPEFRUIT: { Small: 0.5, Medium: 0.5 }, //after cantaloupe
    CANTALOUPE: { Medium: 0.8, Large: 0.2 },
    "SMALL WATERMELON": { Large: 1.0 },
  };

  const probs = createZeroProbs();
  const dist = rules[fruit.toUpperCase()];
  if (!dist) return null;
  Object.assign(probs, dist);

  return normalizeProbs(probs);
}

function getCupSizeProbs(cup) {
  let key = String(cup).trim();

  const rules = {
    AA: { Teen: 0.95, Small: 0.05 },
    A: { Teen: 0.2, Small: 0.8 },
    "28C": { Small: 0.95, Medium: 0.05 },
    "28D": { Small: 0.95, Medium: 0.05 },
    "28DD": { Small: 0.95, Medium: 0.05 },
    "28DDD": { Small: 0.95, Medium: 0.05 },
    B: { Small: 0.95, Medium: 0.05 },
    "30C": { Small: 0.95, Medium: 0.05 },
    "32C": { Small: 0.95, Medium: 0.05 },
    "34C": { Small: 0.95, Medium: 0.05 },
    "36C": { Small: 0.8, Medium: 0.2 },
    "38C": { Small: 0.8, Medium: 0.2 },
    "40C": { Small: 0.8, Medium: 0.2 },
    "30D": { Small: 0.95, Medium: 0.05 },
    "32D": { Small: 0.95, Medium: 0.05 },
    "34D": { Small: 0.5, Medium: 0.5 },
    "36D": { Medium: 0.8, Small: 0.2 },
    "38D": { Medium: 0.8, Small: 0.2 },
    "40D": { Medium: 0.95, Large: 0.05 },
    "42D": { Medium: 0.95, Large: 0.05 },
    "30DD": { Small: 0.95, Medium: 0.05 },
    "32DD": { Small: 0.5, Medium: 0.5 },
    "34DD": { Small: 0.2, Medium: 0.8 },
    "36DD": { Large: 0.05, Medium: 0.95 },
    "38DD": { Large: 0.05, Medium: 0.95 },
    "40DD": { Large: 0.8, Medium: 0.2 },
    "42DD": { Large: 0.8, Medium: 0.2 },
    "30DDD": { Small: 0.2, Medium: 0.8 },
    "32DDD": { Small: 0.05, Medium: 0.95 },
    "34DDD": { Small: 0.05, Medium: 0.95 },
    "36DDD": { Large: 0.5, Medium: 0.5 },
    "38DDD": { Large: 0.5, Medium: 0.5 },
    "40DDD": { Large: 0.95, Medium: 0.05 },
    "42DDD": { Large: 0.95, Medium: 0.05 },
    "30E": { Small: 0.2, Medium: 0.8 },
    "32E": { Small: 0.05, Medium: 0.95 },
    "34E": { Small: 0.05, Medium: 0.95 },
    "36E": { Large: 0.5, Medium: 0.5 },
    "38E": { Large: 0.5, Medium: 0.5 },
    "40E": { Large: 0.95, Medium: 0.05 },
    "42E": { Large: 0.95, Medium: 0.05 },
    "28G": { Medium: 0.95, Large: 0.05 },
    "28H": { Medium: 0.95, Large: 0.05 },
    "28I": { Medium: 0.95, Large: 0.05 },
    "32G": { Large: 0.2, Medium: 0.8 },
    "34G": { Large: 0.2, Medium: 0.8 },
    "36G": { Large: 0.5, Medium: 0.5 },
    "38G": { Large: 0.95, Medium: 0.05 },
    "40G": { Large: 0.95, Medium: 0.05 },
    "42G": { Large: 1 },
    "32F": { Large: 0.2, Medium: 0.8 },
    "34F": { Large: 0.2, Medium: 0.8 },
    "36F": { Large: 0.5, Medium: 0.5 },
    "38F": { Large: 0.95, Medium: 0.05 },
    "40F": { Large: 0.95, Medium: 0.05 },
    "42F": { Large: 1 },
    H: { Large: 1 },
    I: { Large: 1 },
    "J+": { Large: 1 },
  };

  const dist = rules[key];
  if (!dist) return null;

  const probs = createZeroProbs();
  Object.assign(probs, dist);
  return normalizeProbs(probs);
}

const SHIRTSIZES = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"];

// Helper: create a zero-filled probability object
function createShirtZeroProbs() {
  return SHIRTSIZES.reduce((acc, size) => {
    acc[size] = 0;
    return acc;
  }, {});
}

function getAlphaSizeProbs(alpha) {
  // console.log(alpha);
  if (!alpha) return null;
  const rules = {
    XXS: { XXS: 0.95, XS: 0.05 },
    XS: { XS: 0.95, XXS: 0.05 },
    S: { S: 0.8, XS: 0.2 },
    SXXS: { XXS: 0.8, XS: 0.2 },
    SXSXXS: { XS: 0.8, XXS: 0.2 },
    SXS: { XS: 0.8, S: 0.2 },
    XSXXS: { XS: 0.95, XXS: 0.05 },
    M: { S: 0.333, M: 0.333, L: 0.333 },
    L: { M: 0.5, L: 0.5 },
    XL: { L: 0.333, XL: 0.333, XXL: 0.333 },
    XXL: { XL: 0.5, XXL: 0.5 }, //updated 5/10 per Laura
    XXXL: { XXL: 0.5, XXXL: 0.5 },
    "XXXL+": { XXL: 0.2, XXXL: 0.8 }, //updated 5/10
  };

  const probs = createShirtZeroProbs();
  const dist = rules[alpha.toUpperCase()];
  if (!dist) return null;
  Object.assign(probs, dist);
  return normalizeSizeProbs(probs);
}

function getXXSProbs(XXS) {
  if (!XXS) return null;
  // console.log("running xxs");
  // console.log(`XXS is ${XXS}`);
  const rules = {
    Yes: { XXS: 1000 },
    No: {},
  };
  const dist = rules[XXS];
  if (!dist) return null;
  const probs = createShirtZeroProbs();
  Object.assign(probs, dist);
  // console.log("*********** XXS Probs *************");
  // console.log(probs);
  return normalizeSizeProbs(probs);
}

function getNumericTopProbs(numTop) {
  // if (!numTop && numTop !== 0 && numTop !== "0" && numTop !== "00") return null;
  if (numTop === undefined || numTop === null) return null;

  // Keep as string — this is the key change
  let key = String(numTop).trim();

  // Optional: treat very inconsistent entries the same
  // if (key === "0" || key === "00") key = "00";  // or keep separate — your choice

  const rules = {
    "00": { XXS: 0.95, XS: 0.05 },
    0: { XXS: 0.05, XS: 0.95 },
    2: { XS: 0.5, S: 0.5 },
    4: { S: 0.95, XS: 0.05 },
    6: { S: 0.5, M: 0.5 },
    8: { M: 0.5, L: 0.5 },
    10: { M: 0.5, L: 0.5 },
    12: { M: 0.5, L: 0.5 }, // Changed by Laura 5/9
    14: { L: 0.5, XL: 0.5 },
    16: { XL: 0.8, XXL: 0.2 }, // updated 5/10
    18: { XXL: 0.5, XXXL: 0.5 },
    20: { XXL: 0.5, XXXL: 0.5 },
    "20+": { XXL: 0.2, XXXL: 0.8 }, //updated 5/10
  };

  const dist = rules[key];
  if (!dist) return null;

  const probs = createShirtZeroProbs();
  Object.assign(probs, dist);
  return normalizeSizeProbs(probs);
}

function getNumericBottomsProbs(numBottoms) {
  if (numBottoms === undefined || numBottoms === null) return null;
  // if (!numBottoms && numTop !== 0 && numBottoms !== "0" && numBottoms !== "00") return null;

  // Keep as string — this is the key change
  let key = String(numBottoms).trim();

  // Optional: treat very inconsistent entries the same
  // if (key === "0" || key === "00") key = "00";  // or keep separate — your choice
  const rules = {
    "00": { XXS: 0.95, XS: 0.05 },
    0: { XXS: 0.05, XS: 0.95 },
    2: { XS: 0.5, S: 0.5 },
    4: { S: 0.95, XS: 0.05 },
    6: { S: 0.5, M: 0.5 },
    8: { M: 0.5, L: 0.5 },
    10: { M: 0.5, L: 0.5 },
    12: { L: 0.5, M: 0.5 }, //updated 5/10
    14: { L: 0.5, XL: 0.5 }, //updated 5/10
    16: { XL: 0.5, XXL: 0.5 },
    18: { XXL: 0.5, XXXL: 0.5 },
    20: { XXL: 0.5, XXXL: 0.5 },
    "20+": { XXXL: 0.5, XXXXL: 0.5 }, // updated 5/10
  };

  const dist = rules[key];
  if (!dist) return null;

  const probs = createShirtZeroProbs();
  Object.assign(probs, dist);
  return normalizeSizeProbs(probs);
}

function getJeansWaistProbs(waist) {
  if (waist === undefined || waist === null) return null;
  //  alert(waist)
  // if (waist === "I don't know") return null
  // const w = Number(waist);
  // if (isNaN(w)) return null;
  let key = String(waist).trim();

  const rules = {
    23: { XXS: 0.95, XS: 0.05 },
    24: { XS: 0.8, XXS: 0.2 },
    25: { XS: 0.95, S: 0.05 },
    26: { XS: 0.5, S: 0.5 },
    27: { S: 0.95, XS: 0.05 },
    28: { S: 0.5, M: 0.5 },
    29: { M: 0.8, S: 0.2 },
    30: { M: 0.5, L: 0.5 },
    31: { M: 0.5, L: 0.5 },
    32: { L: 0.5, XL: 0.5 },
    33: { XL: 0.5, XXL: 0.5 },
    34: { XL: 0.5, XXL: 0.5 },
    35: { XL: 0.5, XXL: 0.5 },
    36: { XL: 0.5, XXL: 0.5 },
    37: { XL: 0.5, XXL: 0.5 },
    38: { XXL: 0.5, XXXL: 0.5 },
    "39+": { XXXL: 0.5, XXXXL: 0.5 },
  };
  const dist = rules[key];
  if (!dist) return null;

  const probs = createShirtZeroProbs();
  Object.assign(probs, dist);
  return normalizeSizeProbs(probs);
}

function getBraBandProbs(band) {
  if (band === undefined || band === null) return null;
  // const b = Number(band);
  // if (isNaN(b)) return null;

  let key = String(band).trim();

  const rules = {
    28: { XXS: 1.0 },
    30: { XS: 0.5, XXS: 0.5 },
    32: { XS: 0.8, S: 0.2 },
    34: { XS: 0.333, S: 0.333, M: 0.333 },
    36: { S: 0.333, M: 0.333, L: 0.333 },
    38: { M: 0.333, L: 0.333, XL: 0.333 },
    40: { L: 0.333, XL: 0.333, XXL: 0.333 },
    42: { XL: 0.333, XXL: 0.333, XXXL: 0.333 },
    "42+": { XL: 0.333, XXL: 0.333, XXXL: 0.333 },
  };
  const dist = rules[key];
  if (!dist) return null;

  const probs = createShirtZeroProbs();
  Object.assign(probs, dist);
  return normalizeSizeProbs(probs);
}

//temporary global vars for validation
let topShirt;
let secondShirt;

//put boost factor in global scope to access for validation
let boostFactor = 1;
const boostedRankedNormalized = [];
let ranked = [];
//make sizeRecommendation global for logicValidation

function getShirtSizeEstimate(customer, weights, recommendedCup) {
  // console.log("***********customer**********");
  // console.log(customer);
  const experts = [
    {
      name: "alpha",
      answer: customer.alphaSize,
      probs: getAlphaSizeProbs(customer.alphaSize),
      weight: weights.alpha || 1.0,
    },
    {
      name: "numericTop",
      answer: customer.numericTop,
      probs: getNumericTopProbs(customer.numericTop),
      weight: weights.numericTop || 1.0,
    },
    {
      name: "numericBottoms",
      answer: customer.numericBottoms,
      probs: getNumericBottomsProbs(customer.numericBottoms),
      weight: weights.numericBottoms || 1.0,
    },
    {
      name: "jeansWaist",
      answer: customer.jeansWaist,
      probs: getJeansWaistProbs(customer.jeansWaist),
      weight: weights.jeansWaist || 1.0,
    },
    {
      name: "braBand",
      answer: customer.braBand,
      probs: getBraBandProbs(customer.braBand),
      weight: weights.braBand || 1.0,
    },
    {
      name: "xxs",
      answer: customer.xxs,
      probs: getXXSProbs(customer.xxs),
      weight: weights.xxs || 1.0,
    },
  ].filter((e) => e.probs !== null);

  //for validation
  // console.log("*********** experts ***************");
  // console.log(experts);
  sizeExperts = experts;

  if (experts.length === 0) {
    return {
      topSize: null,
      confidence: 0,
      distribution: SHIRTSIZES.map((size) => ({ size, probability: 0 })),
      message: "No usable size information provided",
      numExpertsUsed: 0,
      totalWeight: 0,
    };
  }

  //get customer's alpha size choice

  let alphaSizeChoice;

  experts.forEach((expert) => {
    if (expert.name === "alpha") {
      alphaSizeChoice = expert.answer;
    }
  });

  if (alphaSizeChoice?.substr(0, 2) === "SX") alphaSizeChoice = "S";
  if (alphaSizeChoice?.substr(0, 2) === "XS") alphaSizeChoice = "XS";

  const totalProbs = createShirtZeroProbs();
  let totalWeight = 0;

  experts.forEach((expert) => {
    const w = expert.weight;
    totalWeight += w;
    SHIRTSIZES.forEach((size) => {
      totalProbs[size] += expert.probs[size] * w;
    });
  });

  // console.log("total weight");
  // console.log(totalWeight);

  // Weighted average
  SHIRTSIZES.forEach((size) => {
    totalProbs[size] /= totalWeight;
  });

  //normalize total probs
  const totalProbsTotal = Object.values(totalProbs).reduce(
    (sum, value) => sum + value,
    0,
  );

  const normalizedProbs = Object.fromEntries(
    Object.entries(totalProbs).map(([size, prob]) => [
      size,
      prob / totalProbsTotal,
    ]),
  );
  // console.log("Normalized Total Probs");
  // console.log(normalizedProbs);

  // Sort by descending probability
  ranked = SHIRTSIZES.map((size) => ({
    size,
    probability: normalizedProbs[size],
  })).sort((a, b) => b.probability - a.probability);

  const height = answersObject?.height?.answer ?? "";

  if (height === "Under 5 feet") {
    boostFactor = 5;
  } else if (height === `5'0" to  5'3"`) {
    boostFactor = 2;
  } else {
    boostFactor = 1;
  }

  const boostedRanked = ranked.map((item) => {
    if (item.size === "XXS" || item.size === "XS") {
      return { size: item.size, probability: boostFactor * item.probability };
    } else {
      return { size: item.size, probability: item.probability };
    }
  });

  // get total of probabilities to normalize
  const boostedRankedTotal = boostedRanked.reduce(
    (sum, item) => sum + item.probability,
    0,
  );

  boostedRankedNormalized.splice(0, boostedRankedNormalized.length);

  boostedRanked.forEach((entry) => {
    boostedRankedNormalized.push({
      size: entry.size.trim(),
      probability: entry.probability / boostedRankedTotal,
    });
  });

  boostedRankedNormalized.sort((a, b) => b.probability - a.probability);

  const top = { ...boostedRankedNormalized[0] };
  const second = { ...boostedRankedNormalized[1] };
  const sizeIndexes = new Map(SHIRTSIZES.map((size, index) => [size, index]));
  const alphaIndex = sizeIndexes.get(alphaSizeChoice);
  const topIndex = sizeIndexes.get(top.size);
  const secondIndex = sizeIndexes.get(second.size);
  const topDifference = Math.abs(alphaIndex - topIndex);
  const secondDifference = Math.abs(alphaIndex - secondIndex);

  let recommendedSize = top.size;

  let alphaSizeAdjustment = "No Adjustment";
  let alphaSizeRecommendation = "";

  //pick size closest to customer's alpha size choice

  if (Math.abs(top.probability - second.probability) < 0.1) {
    alphaSizeAdjustment = "Less than 0.1 difference between top two sizes";
    if (topDifference < secondDifference) {
      recommendedSize = top.size;
      alphaSizeRecommendation =
        "Top size is closest to customer's alpha choice";
    } else {
      recommendedSize = second.size;
      alphaSizeRecommendation =
        "Second size is closest to customer's alpha choice";
    }
  }

  //if recommended cup is Large, tell customer we don't have a size that fits you yet

  let largeCupFlag = false;

  if (recommendedCup === "Large") {
    largeCupFlag = true;
  }

  let actionAdvice = "";
  let actionSummary = "";

  actionSummary = `Your shirt size: ${recommendedSize}`;

  if (recommendedSize === "XXXL") {
    actionAdvice = `We will be offering XXXL soon - stay in touch.`;
  } else {
    actionAdvice = `We think our size ${recommendedSize} is best for you.`;
  }

  return {
    topSize: recommendedSize,
    confidence: Math.round(top.probability * 100),
    distribution: ranked.map((r) => ({
      size: r.size,
      probability: Math.round(r.probability * 1000) / 10, // 1 decimal place
    })),
    numExpertsUsed: experts.length,
    totalWeight: Math.round(totalWeight * 10) / 10,
    effectiveWeights: experts.reduce((acc, e) => {
      acc[e.name] = Math.round(e.weight * 10) / 10;
      return acc;
    }, {}),
    actionAdvice,
    actionSummary,
    alphaSizeAdjustment,
    alphaSizeRecommendation,
    largeCupFlag,
    confidenceCategory:
      top.probability >= 0.75
        ? "high"
        : top.probability >= 0.6
          ? "good"
          : "moderate/low",
  };
}

async function submitData(entryArray) {
  const formId = "1FAIpQLSc34-lyIAp8v-9arCGSON4YuSKG91XWhoe4M7cbWPk6-x2AXQ";

  const url = `https://docs.google.com/forms/d/e/${formId}/formResponse`;

  const payload = new URLSearchParams(entryArray);

  try {
    await fetch(url, {
      method: "POST",
      body: payload,
      mode: "no-cors",
      redirect: "follow",
    });
  } catch (error) {
    console.error("Submission error:", error);
  }
}

// PDP EMBED — initSurvey() is invoked by the PDP host (sections/main-product-
// laura-tempesta.liquid) via window.initSurvey() on every modal open, so the
// quiz resets to question 1 each time. The auto-invocation that was here is
// removed so re-opens don't double-init on the standalone harness either.
